import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "double-line" }, "Charged Services", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "double-line" }, "Access Management", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "double-line" }, "Case History", -1)
const _hoisted_4 = { class: "double-line" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" (Special Request) ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_contact_persons = _resolveComponent("contact-persons")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form_item, {
      prop: "tenantName",
      label: _ctx.trans('label.company-name'),
      rules: {
                  required: true,
                  message: _ctx.trans('message.field_require', _ctx.trans('label.company-name')),
                }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.tenantName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.tenantName) = $event)),
          maxlength: 200,
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label", "rules"]),
    _createVNode(_component_el_form_item, {
      prop: "suite_FloorID",
      label: _ctx.trans('label.floor'),
      rules: {
                  required: true,
                  message: _ctx.trans('message.field_require', _ctx.trans('label.floor')),
                }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_cascader, {
          modelValue: _ctx.floorIds,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.floorIds) = $event)),
          options: _ctx.options,
          props: {
                   expandTrigger: 'hover',
                   emitPath: false,
                   multiple: true,
                 },
          filterable: ""
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["label", "rules"]),
    _createVNode(_component_el_form_item, {
      prop: "suite_Name",
      label: _ctx.trans('label.suite-no'),
      rules: {
                  required: true,
                  message: _ctx.trans('message.field_require', _ctx.trans('label.suite-no')),
                }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.suite_Name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.suite_Name) = $event)),
          maxlength: 200,
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label", "rules"]),
    _createVNode(_component_el_form_item, {
      prop: "contactPerson",
      label: _ctx.trans('label.key-contact-person')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"width":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactPerson1,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.contactPerson1) = $event)),
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactPerson2,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.contactPerson2) = $event)),
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactPerson3,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.contactPerson3) = $event)),
                  maxlength: "50",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_el_form_item, {
      prop: "contactNo",
      label: _ctx.trans('label.key-contact-no')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"width":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactNo1,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.contactNo1) = $event)),
                  maxlength: 20,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactNo2,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.contactNo2) = $event)),
                  maxlength: 20,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.contactNo3,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.contactNo3) = $event)),
                  maxlength: 20,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_el_form_item, {
      prop: "suite_Phone",
      label: _ctx.trans('label.reception-phone')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.suite_Phone,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.suite_Phone) = $event)),
          maxlength: 20,
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["label"]),
    _createVNode(_component_el_form_item, { prop: "chargedServices" }, {
      label: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.chargedServices,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.chargedServices) = $event)),
          type: "textarea",
          maxlength: 500,
          autosize: {
                minRows: 5,
                maxRows: 10
              },
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { prop: "accessManagement" }, {
      label: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.accessManagement,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.accessManagement) = $event)),
          type: "textarea",
          maxlength: 500,
          autosize: {
                minRows: 5,
                maxRows: 10
              },
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { prop: "caseHistory" }, {
      label: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.caseHistory,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.caseHistory) = $event)),
          type: "textarea",
          maxlength: 500,
          autosize: {
                minRows: 5,
                maxRows: 10
              },
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { prop: "remarks" }, {
      label: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.trans('label.remarks')) + " ", 1),
          _hoisted_5,
          _hoisted_6
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.model.remarks,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.remarks) = $event)),
          type: "textarea",
          maxlength: 1000,
          autosize: {
                minRows: 5,
                maxRows: 10
              },
          "show-word-limit": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_contact_persons)
  ], 64))
}